export default "__VITE_ASSET__KpCufjBu__"